var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerificationFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 120,
    viewBox: "0 0 128 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_111_1286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.036 119.007L13.9844 119.042C8.95803 119.044 4.4556 116.443 1.94092 112.085C0.683425 109.906 0.05454 107.516 0.0537118 105.125C0.0528835 102.734 0.680421 100.343 1.93611 98.1629L51.9301 7.03255C54.442 2.67274 58.9427 0.069124 63.969 0.0673837C68.9954 0.0656434 73.4978 2.66614 76.0128 7.02421L126.076 98.1312C127.33 100.305 127.958 102.692 127.958 105.082C127.958 107.471 127.33 109.862 126.074 112.042C123.563 116.402 119.062 119.006 114.036 119.007ZM1.31137 105.123C1.3112 107.299 12.3516 102.61 13.4953 104.592C15.7832 108.556 9.41103 117.787 13.9839 117.785C13.9839 117.785 122.702 115.38 124.988 111.414C126.13 109.431 126.701 107.256 126.7 105.081C126.699 102.906 126.127 100.731 124.983 98.7485L74.9195 7.64152C72.6381 3.6883 68.5424 1.32235 63.9694 1.32393C59.3987 1.32551 1.31154 102.946 1.31137 105.123Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7308 105.534C84.0461 105.534 96.4616 93.1024 96.4616 77.7671C96.4616 62.4317 84.0461 50 68.7308 50C53.4155 50 41 62.4317 41 77.7671C41 93.1024 53.4155 105.534 68.7308 105.534Z",
    fill: "#DC3545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9616 74.7671C91.9616 89.8269 79.7693 102.034 64.7308 102.034C49.6923 102.034 37.5 89.8269 37.5 74.7671C37.5 59.7073 49.6923 47.5 64.7308 47.5C79.7693 47.5 91.9616 59.7073 91.9616 74.7671Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7356 91.7879C66.1418 91.7879 67.2818 90.6465 67.2818 89.2385C67.2818 87.8304 66.1418 86.689 64.7356 86.689C63.3294 86.689 62.1895 87.8304 62.1895 89.2385C62.1895 90.6465 63.3294 91.7879 64.7356 91.7879Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.725 57.7453C64.4911 59.3015 64.9102 59.6271 64.9125 66.336C64.9148 73.0449 66.305 82.0399 64.7334 82.0405C63.1617 82.041 62.5869 63.4773 57.1295 61.8343C50.7131 59.9026 65.4821 52.7077 64.725 57.7453Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_111_1286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationFailed);
export default __webpack_public_path__ + "static/media/verification-failed.98ae23382add39b7fb7a7bc0c2b4c7f8.svg";
export { ForwardRef as ReactComponent };